import type {SupportContext} from "../model/user/SupportContext.ts";

const FIELD = "supportContext";

type EntryState = Record<string, unknown> | null;

const entryState = (): EntryState => window.history.state as EntryState;

export const sameSupportContext = (a: SupportContext | null, b: SupportContext | null): boolean =>
    (a?.type ?? null) === (b?.type ?? null) && (a?.no ?? null) === (b?.no ?? null);

/**
 * Each browser history entry remembers the support context it was shown in
 * (#56913), so browser back and forward can return to that context instead of
 * opening an admin page in the dealer view or the other way round.
 */
export const pushSupportContextEntry = (path: string, context: SupportContext | null): void => {
    window.history.pushState({[FIELD]: context}, "", path);
};

export const markSupportContextEntry = (context: SupportContext | null): void => {
    const state = entryState();
    if (state && FIELD in state && sameSupportContext(state[FIELD] as SupportContext | null, context)) return;
    // keep the router's own fields of the entry
    window.history.replaceState({...state, [FIELD]: context}, "");
};

/** The context of the current entry; undefined for entries from before the context was tracked. */
export const supportContextOfEntry = (): SupportContext | null | undefined => {
    const state = entryState();
    return state && FIELD in state ? state[FIELD] as SupportContext | null : undefined;
};
